module.exports = __webpack_public_path__ + "acdbcb440cb447f4b8b9fa2b32db0183.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-salesforce.png
// module id = 279
// module chunks = 0